import BaseDataProcessor from './baseDataProcessor';
import { humanizeTimeSpan } from '../../../../../utilities/dateTime';

export default class GoalsAndAveragesDataProcessor extends BaseDataProcessor {
  constructor(apiStatisticsData, interval) {
    super();

    this.apiStatisticsData = apiStatisticsData;
    this.interval = interval;
  }

  get apiData() {
    return this.apiStatisticsData;
  }

  get data() {
    if (this.apiStatisticsData) {
      const { pointsAverage, timePrayedAverage, iaksAverage } = this.apiStatisticsData;
      return [
        { primaryText: pointsAverage, secondaryText: 'seeds' },
        { primaryText: humanizeTimeSpan(timePrayedAverage), secondaryText: 'prayed' },
        { primaryText: iaksAverage, secondaryText: 'IAK-s' },
      ];
    } else {
      return [];
    }
  }

  get chartData() {
    if (this.apiStatisticsData) {
      const { iaksGoalPercentage, timePrayedGoalPercentage, pointsGoalPercentage } = this.apiStatisticsData;
      return [
        { x: 'IAK goal', y: iaksGoalPercentage },
        { x: 'Praying goal', y: timePrayedGoalPercentage },
        { x: 'Seed goal', y: pointsGoalPercentage }
      ];
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/dataProcessors/goalsAndAveragesDataProcessor.js